import { IOfferDesktop } from '../../repositories/offers-comparison/entities/offer/OfferDesktop';
import { EFieldGroupName, EFieldName } from '../../types/field';

export function transformComparisonFields({ fields }: IOfferDesktop) {
  return fields.map(field => ({
    ...field,
    name: field.name as unknown as EFieldGroupName,
    items: field.items.map(item => item as unknown as EFieldName),
  }));
}
